module.exports = __webpack_public_path__ + "static/assets/d22f147c89c1f8e8769be5f119415fa9.ttf";